import { useSnackbar } from 'notistack';
import * as React from 'react';
import { useAppSelector } from 'store/store';

export const useNotificationsHandler = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { notification } = useAppSelector((state) => state.notifications);

  React.useEffect(() => {
    if (notification) {
      enqueueSnackbar(notification.message, {
        variant: notification.type,
      });
    }
  }, [notification, enqueueSnackbar]);
};
